module.exports = __webpack_public_path__ + "static/media/mule-deer.facc0437.webp";